const menu = [
  {
    name: 'Home',
    title: 'home',
    router: true,
  },
  {
    name: 'About',
    title: 'about',
    router: true,
  },
  {
    name: 'Portfolio',
    title: 'portfolio',
    router: true,
  },
  {
    name: 'Contact',
    title: 'contact',
    router: false,
  },
];

const social = [
  {
    name: 'GitHub',
    icon: ['fab', 'github'],
    url: 'https://github.com/javarcast',
    color: 'bg-github',
  },
  {
    name: 'LinkedIn',
    icon: ['fab', 'linkedin'],
    url: '#',
    color: 'bg-linkedin',
  },
  {
    name: 'Skype',
    icon: ['fab', 'linkedin'],
    url: '#',
    color: 'bg-linkedin',
  },
];

export {
  menu,
  social,
};
